// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const qa = {
  name: "qa",
  production: false,
  domain: "https://www.qa.thermofisher.com",
  services: {
    cloudReferrer: "https://test.apps.thermofisher.com/apps/dashboard/#/",
    // loginRedirect: host+'/auth/login?returnUrl='+host+'/'+iso.toLocaleLowerCase()+'/'+lang+'/home.html',
    rpUrls:
      "/api-gateway/identity-authorization/identity/auth-services/rp/urls/",
    reAuthFed:
      "/api-gateway/identity-authorization/identity/fed/findfederateduser",
    oidcRefreshToken:
      "/api-gateway/identity-authorization/identity/auth/refresh-token",
    partnerLogin: "/auth/login",
    partnerLogout: "/auth/logout",
    //  sessionLoginRedirect:  "/auth/login?returnUrl=" + '"+encodeURIComponent(window.location.href)+"',
    loginErrorUrl: "/account-center/loginError.html",
    //idleSessionReturnUrl:  "/api-gateway/identity-authorization/identity/oidc/op/authorize?response_type=code&client_id=" + clientId + "&redirect_uri=" +  "/api-gateway/identity-authorization/identity/auth/token&scope=openid profile email&state={'u':" + sessionLoginRedirect + "}&completion_mode=STANDARD",
    // envParams:  '/api-gateway/identity-authorization/identity/oidc/op/authorize?response_type=code&client_id=' + clientId + '&redirect_uri=' +  '/api-gateway/identity-authorization/identity/auth/token&scope=openid profile email&state=',
    fedOIDCAuthorized:
      "/api-gateway/identity-authorization/identity/oidc/op/federated-authorize",
    otpUpdate: "/api-gateway/identity-authorization/identity/otp/update",
    editEmail: "/identity/edit-email.html",
    verifyEmail: "/identity/verify-email.html",
    missingEmail: "/identity/missing-email.html",
    cloudProxy: "/account-center/cloud-proxy.html?mode=afterLogin",
    updatePassword: "/identity/auth-ui/password/update.html",
    marketingConsent: "/identity/auth-ui/consent/marketing.html",
    verifyAuthEmail: "/identity/auth-ui/email/verify.html",
    missingAuthEmail: "/identity/auth-ui/email/missing.html",
    aspireRegLink: "/global-registration/aspire",
    cdcam: {
      identity: {
        federation: {
          enabled: true,
          find_federated:
            "/api-gateway/identity-authorization/identity/fed/findfederateduser",
        },
        liteRegCheck: "/identity/api/cip/v1/literegistered/",
        rpUrls:
          "/api-gateway/identity-authorization/identity/auth-services/rp/urls/",
        updatedNotificationLink:
          "https://www.qa.thermofisher.com/api-gateway/accounts/updated/notification/",
      },
    },
  },
  adobe: {
    digitalData: "/etc/designs/lifetech/clientlibs/digitaldata.min.js",
    enabled: true,
    launch: "ENe956028acf6f4129a803968d774515c2-development",
  },
  pages: {
    loginError: "/account-center/loginError.html?source=gigyajs-proxy",
    contact_us: '/us/en/home/technical-resources/contact-us.html',
    privacy_policy: '/us/en/home/global/privacy-policy.html',
    policy_freight: '/us/en/home/global/online-pricing-policy.html',
    terms_condition: '/us/en/home/global/terms-and-conditions.html',
    china: {
      contact_us_cn: '/cn/zh/home/hotline-guideline.html',
      business_check: 'https://218.242.124.22:8082/businessCheck/verifKey.do?showType=extShow&serial=9031000020171215105412000002252469-SAIC_SHOW_310000-4028e4cb6493ac2c0164c34158830f04018&signData=MEUCIGaAKW51heNd3cUsvTfF7YfkQoSdAyn4cx1XhwWh1t7BAiEAj22lrLm+yIbfvVqeOKnPa+Pz7/e6ouAI9EC1cJRPHRs=',
      icp_registration_number: 'https://beian.miit.gov.cn/',
      license: '/cn/zh/home/global/licenses-cn.html'
    }
  },
  resources: {
    reCaptchaV3: {
      siteKey: "6LfEnt8ZAAAAAK2c7EMp83J6HpMTR6lOmnRiUj0e",
    },
    reCaptchaV2: {
      siteKey: "6LfvDM0ZAAAAAIlBg3xXaej7CAN-seW-W4iHN1pH",
    },
  },
  shared_static: {
    global: "/shared-static/scripts/global-variables.js",
  },
  accountCreationHidden: {
    clientIds: ["RPPo2ZDT5n5nvY2o2awK_Egw"],
  },
};
